export const getExtraById = (state) => (extra, trip) => {
  const e = state.extrasByIdTrip[extra.id+'-'+trip];
  if (e && e.quantity > 0) {
    return e.quantity;
  }
  return 0;
}

export const sumExtras = (state) => {
  let sum = 0;
  for (let [key, extra] of Object.entries(state.extrasByIdTrip)) {
    sum += extra.price * extra.quantity;
  }
  return sum;
}

export const runValidationForm = (state) => (formName) => {
  if (formName === state.validateFormName) {
    return true;
  }
  return false;
}

export const logoUrl = (state) => {
    if (state.settings) {
      return state.settings.logo;
    }
    return 'https://api.btransfer.mx/uploads/btransfer-logo.png';
}

export const companyDisabledDates = (state) => {
  const data = state.staticCompanySettings && state.staticCompanySettings.disabledDates;
  return data || [];
}
